module.exports = __webpack_public_path__ + "fonts/Inter-300-greek39.eb1153e.woff2";